
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getProducts } from "api/thunk/products/getActions/getProducts";
import { getProductsByMarathonId } from "api/thunk/products/getActions/getProductsByMarathonId";
import { getProductByProductId } from "api/thunk/products/getActions/getProductByProductId";
import { createProduct } from "api/thunk/products/postActions/createProduct";
import { updateProduct } from "api/thunk/products/putActions/updateProduct";
import { deleteProductByProductId } from "api/thunk/products/deleteActions/deleteProductByProductId";
import { getUserMarathonProducts } from "api/thunk/products/getActions/getUserMarathonProducts";

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.productsById.params.products = action.payload;
    },
    setProductQuantity: (state, action) => {
      state.productsById.params.quantities = action.payload;
    },
    setProductsPage: (state, action: PayloadAction<number>) => {
      state.products.params.page = action.payload;
    },
    setProductsPageSize: (state, action: PayloadAction<number>) => {
      state.products.params.pageSize = action.payload;
      state.products.params.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      //get_products
      .addCase(getProducts.pending, (state) => {
        state.products.response.loading = true;
        state.products.response.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.products.response.loading = false;
        state.products.response.data = action.payload;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.products.response.loading = false;
        state.products.response.error =
          action.error.message || "Неизвестная ошибка";
        state.products.response.data = null;
      })
      //
      .addCase(getUserMarathonProducts.pending, (state) => {
        state.userMarathonProducts.response.loading = true;
        state.userMarathonProducts.response.error = null;
      })
      .addCase(getUserMarathonProducts.fulfilled, (state, action) => {
        state.userMarathonProducts.response.loading = false;
        state.userMarathonProducts.response.data = action.payload;
      })
      .addCase(getUserMarathonProducts.rejected, (state, action) => {
        state.userMarathonProducts.response.loading = false;
        state.userMarathonProducts.response.error =
          action.error.message || "Неизвестная ошибка";
        state.userMarathonProducts.response.data = null;
      })
      //get_products_by_marathon_id
      .addCase(getProductsByMarathonId.pending, (state) => {
        state.productsById.response.loading = true;
        state.productsById.response.error = null;
      })
      .addCase(getProductsByMarathonId.fulfilled, (state, action) => {
        state.productsById.response.loading = false;
        state.productsById.response.data = action.payload;
      })
      .addCase(getProductsByMarathonId.rejected, (state, action) => {
        state.productsById.response.loading = false;
        state.productsById.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productsById.response.data = null;
      })
      //get_products_by_product_id
      .addCase(getProductByProductId.pending, (state) => {
        state.productByProductId.response.loading = true;
        state.productByProductId.response.error = null;
      })
      .addCase(getProductByProductId.fulfilled, (state, action) => {
        state.productByProductId.response.loading = false;
        state.productByProductId.response.data = action.payload;
      })
      .addCase(getProductByProductId.rejected, (state, action) => {
        state.productByProductId.response.loading = false;
        state.productByProductId.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productByProductId.response.data = null;
      })
      //create_product
      .addCase(createProduct.pending, (state) => {
        state.product.loading = true;
        state.product.error = null;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.product.loading = false;
        state.product.data = action.payload;
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.product.loading = false;
        state.product.error =
          action.error.message || "Неизвестная ошибка";
        state.product.data = null;
      })
      //update_product
      .addCase(updateProduct.pending, (state) => {
        state.updateProduct.loading = true;
        state.updateProduct.error = null;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.updateProduct.loading = false;
        state.updateProduct.data = action.payload;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.updateProduct.loading = false;
        state.updateProduct.error =
          action.error.message || "Неизвестная ошибка";
        state.updateProduct.data = null;
      })
      //delete_product_by_product_id
      .addCase(deleteProductByProductId.pending, (state) => {
        state.deleteProduct.loading = true;
        state.deleteProduct.error = null;
      })
      .addCase(deleteProductByProductId.fulfilled, (state, action) => {
        state.deleteProduct.loading = false;
        state.deleteProduct.data = action.payload;
      })
      .addCase(deleteProductByProductId.rejected, (state, action) => {
        state.deleteProduct.loading = false;
        state.deleteProduct.error =
          action.error.message || "Неизвестная ошибка";
        state.deleteProduct.data = null;
      })
  },
});

export const { setProducts, setProductQuantity, setProductsPage, setProductsPageSize } = productsSlice.actions;
export default productsSlice.reducer;

